export const getUTMParameters = () => {
  if (typeof window === 'undefined') {
    return '';
  }

  return window.location.search.replace('?', '');
};
